import {Entity} from 'app/core/main.entity';
import {Transform} from 'class-transformer';
import {SwitchCheckboxCollection, SwitchRadioCollection} from 'app/entities/switchCollection.entity';
import {Subscription} from 'rxjs';
import {BlockElementLabel} from 'app/entities/blockElements/blockElementContainer';
import {AppColorList} from 'app/entities/enums';
import 'reflect-metadata';

export class SwitchItem extends Entity {
  id: string | number;

  title?: string = null;
  selectedTitle?: string = null;

  icon?: string = null;
  color?: AppColorList | string = null;
  selectedColor?: AppColorList | string = null;
  selectedBackground?: AppColorList | string = null;

  disabled? = false;
  required? = false;
  selected? = false;
  visible? = true;
  indeterminate? = false;
  subItems?: SwitchItem[] = [];
  subCollection?: SwitchCheckboxCollection | SwitchRadioCollection = null;

  prefix?: SwitchItemTitlePrefix = null;

  label?: BlockElementLabel = null;

  @Transform(({value}) => {

    // for some shity reason, it converts CustomDate back to Date, probably need to do something with prototype of CustomDate
    if (value) {
      for (const [k, v] of Object.entries(value)) {
        if (v instanceof Date) {
          value[k] = v.toCustomDate();
        }
      }
    }

    return value;
  })
  data?: any = null;
  sub?: Subscription = null;

  constructor(data: Partial<SwitchItem> = null) {
    super();

    Object.assign(this, data);
  }
}

export class SwitchItemTitlePrefix {
  text: string;
  color: AppColorList;
}
